import React from "react";
import { Navigate, Outlet, useNavigation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { logger } from "../../utility/logger";
import { LoadingSpinner } from "../LoadingSpinner";

export const RegisteredUser = () => {
  const { isNewUser } = useUser();
  const navigation = useNavigation();

  if (isNewUser) return <Navigate to="/create-account" />;
  logger.log("Is user is a new user: " + isNewUser);

  if (navigation.state === "loading")
    return (
      <div className="center w-[100vw]">
        <LoadingSpinner size="40px" className="h-[223px]" />
      </div>
    );

  return <Outlet />;
};
